export default __webpack_public_path__ + "static/media/ava-02.f1750939.png";